import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { useSession, useAnalytics } from 'hooks';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { getDashboardPath } from 'hooks/useSession';

import SignUp from 'components/user/SignUp/SignUp';

const SignUpPage = () => {
  const { authenticated, user } = useSession();
  const { trackEvent } = useAnalytics();

  useEffect(() => {
    trackEvent(MIXPANEL_EVENTS.signUp);
  }, [trackEvent]);

  if (authenticated) {
    return <Redirect to={getDashboardPath(user.type)} />;
  }

  return <SignUp />;
};

export default SignUpPage;
